import { FC, useState } from 'react';
import { Layout, Menu } from 'antd';
import { useTranslation } from 'react-i18next';
import { Link, useLocation } from 'react-router-dom';

import { sidebarOpenedStorage } from 'utils/storage';
import { ISidebarProps } from './types';
import { SidebarMenuType } from '../../types';
import useIsMobile from 'hooks/useIsMobile';

const { Sider } = Layout;

const Sidebar: FC<ISidebarProps> = ({ sidebarMenu }) => {
  const isMobile = useIsMobile();
  const { pathname } = useLocation();
  const [isOpen, setOpen] = useState(sidebarOpenedStorage.get() === '1');
  const { t } = useTranslation();

  const onSidebarChange = (value: boolean) => {
    if (value) {
      sidebarOpenedStorage.set('1');
    } else {
      sidebarOpenedStorage.remove();
    }

    setOpen(value);
  };

  const renderItemChildren = (item: SidebarMenuType) => {
    return item.children?.map(child => ({
      key: `${child.url}-${child.key}`,
      label: (
        <Link to={`${item.key}/${child.url}`}>
          {t(`sidebar.${child.label}`)}
        </Link>
      )
    }));
  };

  const renderItemLabel = (item: SidebarMenuType) => {
    if (item.children) {
      return t(`sidebar.${item.label}`);
    }

    if (item.url) {
      return (
        <a href={item.url} target="_blank" rel="noreferrer">
          {t(`sidebar.${item.label}`)}
        </a>
      );
    }

    if (item.to) {
      return <Link to={item.to}>{t(`sidebar.${item.label}`)}</Link>;
    }
  };

  return (
    <Sider
      onCollapse={value => onSidebarChange(value)}
      collapsed={isOpen || isMobile}
      collapsible={!isMobile}
    >
      <Menu
        selectedKeys={[pathname.split('/')[1]]}
        style={{ background: '#F5F7FF' }}
        items={[...sidebarMenu]?.map(item => ({
          ...item,
          label: (
            <>
              {renderItemLabel(item)}
              <div
                style={{
                  position: 'absolute',
                  zIndex: -1,
                  inset: 0
                }}
              />
            </>
          ),
          children: renderItemChildren(item)
        }))}
        mode="inline"
      />
    </Sider>
  );
};

export default Sidebar;
